export const FALSY = {
  true: { id: 'true', value: 'True' },
  false: { id: 'false', value: 'False' },
  yes: { id: 'yes', value: 'Yes' },
  no: { id: 'no', value: 'No' },
}

export const FALSEY_TOGGLE = {
  true: { id: 'true', value: 'True', label: 'True' },
  false: { id: 'false', value: 'False', label: 'False' },
  yes: { id: 'yes', value: 'Yes', label: 'Yes' },
  no: { id: 'no', value: 'No', label: 'No' },
}

export const STATUS = {
  active: { id: 'active', value: 'Active' },
  inactive: { id: 'inactive', value: 'Inactive' },
  scheduled: { id: 'scheduled', value: 'Scheduled' },
  cancelled: { id: 'cancelled', value: 'Cancelled' },
  completed: { id: 'completed', value: 'Completed' },
  progress: { id: 'progress', value: 'In Progress' },
  expired: { id: 'expired', value: 'Expired' },
  draft: { id: 'draft', value: 'Draft' },
  paid: { id: 'paid', value: 'Paid' },
  unpaid: { id: 'Committed', value: 'Unpaid' },
  refunded: { id: 'refunded', value: 'Refunded' },
  partialrefund: { id: 'partialrefund', value: 'Partial Refund' },
  pendingActive: { id: 'pendingActive', value: 'Pending Active' },
  transferredOut: { id: 'transferredOut', value: 'Transferred Out' },
  allmemberstatus: { id: 'allmemberstatus', value: 'All Member Status' },
  pending: { id: 'pending', value: 'Pending' },
  allmembershipstatus: { id: 'allmembershipstatus', value: 'All Membership Status' },
  allorderstatus: { id: 'allorderstatus', value: 'All Order Status' },
  allstatus: { id: 'allstatus', value: 'All Status' },
  processing: { id: 'processing', value: 'Processing' },
  instalmentPlan: { id: 'instalmentPlan', value: 'Instalment Plan' },
}

export const NOTIFICATIONSTATUS = {
  unread: {
    id: 'unread',
    value: 'Unread',
  },
  read: {
    id: 'read',
    value: 'Read',
  },
  failed: {
    id: 'failed',
    value: 'Failed',
  },
  today: {
    id: 'today',
    value: 'Today',
  },
  all: {
    id: 'all',
    value: 'All',
  },
} as const

export const GENDER = {
  male: {
    id: 'male',
    value: 'Male',
  },
  female: {
    id: 'female',
    value: 'Female',
  },
} as const

export const GENDER_IDENTITY = {
  male: {
    id: 'male',
    value: 'Male',
  },
  female: {
    id: 'female',
    value: 'Female',
  },
  nonBinary: {
    id: 'nonBinary',
    value: 'Non-binary/gender fluid',
  },
  differentidentity: {
    id: 'differentidentity',
    value: 'Different Identity',
  },
  prefernottosay: {
    id: 'prefernottosay',
    value: 'Prefer not to say',
  },
} as const

export const LEGACY_GENDER = {
  male: {
    id: 'Male',
    value: 'Male',
  },
  female: {
    id: 'Female',
    value: 'Female',
  },
} as const

export const LEGACY_GENDER_IDENTITY = {
  male: {
    id: 'Male',
    value: 'Male',
  },
  female: {
    id: 'Female',
    value: 'Female',
  },
  nonBinary: {
    id: 'Non-binary/gender fluid',
    value: 'Non-binary/gender fluid',
  },
  differentidentity: {
    id: 'Different Identity',
    value: 'Different Identity',
  },
  prefernottosay: {
    id: 'Prefer not to say',
    value: 'Prefer not to say',
  },
} as const

export const DATES = {
  beforeexpiry: { id: 'beforeexpiry', value: 'Before Expiry Date' },
  afterexpiry: { id: 'afterexpiry', value: 'After Expiry Date' },
  beforestart: { id: 'beforestart', value: 'Before Start Date' },
  afterstart: { id: 'afterstart', value: 'After Start Date' },
  specificdate: { id: 'specificdate', value: 'Specific Date' },
}

export const TIME = {
  am: { id: 'am', value: 'am' },
  pm: { id: 'pm', value: 'pm' },
}

export const DAYS_WEEKS_MONTHS = {
  years: { id: 'Years', value: 'Years' },
  months: { id: 'Months', value: 'Months' },
  weeks: { id: 'Weeks', value: 'Weeks' },
  days: { id: 'Days', value: 'Days' },
  days1: { id: 'days1', value: '1 Day' },
  days2: { id: 'days2', value: '2 Days' },
  days3: { id: '3days', value: '3 Days' },
  weeks1: { id: 'weeks1', value: '1 Week' },
  weeks2: { id: 'weeks2', value: '2 Weeks' },
  weeks3: { id: 'weeks3', value: '3 Weeks' },
  months1: { id: 'months1', value: '1 Month' },
}

export const FORM = {
  type: {
    membership: { id: 'membership', value: 'Membership' },
    event: { id: 'event', value: 'Event' },
  },
  status: {
    active: STATUS.active,
    inactive: STATUS.inactive,
    draft: STATUS.draft,
  },
}

export const NOTIFICATIONS = {
  status: {
    read: {
      id: 'read',
      value: 'Read',
    },
    unread: {
      id: 'unread',
      value: 'Unread',
    },
    failed: {
      id: 'failed',
      value: 'Failed',
    },
  },
  type: {
    export: {
      id: 'export',
      value: 'Export',
    },
    duplicate: {
      id: 'duplicate',
      value: 'Duplicate',
    },
    download: {
      id: 'download',
      value: 'Download',
    },
    sync: {
      id: 'sync',
      value: 'Sync',
    },
    email: {
      id: 'email',
      value: 'Email',
    },
  },
}

export const SOURCE = {
  adminportal: { id: 'adminportal', value: 'Admin Portal' },
  event: { id: 'event', value: 'Event Form' },
  membership: { id: 'membership', value: 'Membership Form' },
  paymentcampaign: { id: 'paymentcampaign', value: 'Payment Campaign' },
  shop: { id: 'shop', value: 'Shop Form' },
  clubshop: { id: 'clubshop', value: 'Club Shop' },
}

export const PRODUCT = {
  dates: {
    beforeproductexpiry: { id: 'beforeproductexpiry', value: 'Before Product Expiry Date' },
    afterproductexpiry: { id: 'afterproductexpiry', value: 'After Product Expiry Date' },
    beforeproductstart: { id: 'beforeproductstart', value: 'Before Product Start Date' },
    afterproductstart: { id: 'afterproductstart', value: 'After Product Start Date' },
    specificdate: DATES.specificdate,
  },
  types: {
    membership: { id: 'membership', value: 'Membership', label: 'Membership' },
    addon: { id: 'addon', value: 'Shop', label: 'Shop' }, // Add-on
    event: { id: 'event', value: 'Event', label: 'Event' },
    team: { id: 'team', value: 'Team', label: 'Team' },
  },
  formProduct: {
    product: {
      id: 'product',
      value: 'Main Products',
    },
    addon: {
      id: 'addon',
      value: 'Add-ons',
    },
  },
  formProductGroups: {
    productGroup: {
      id: 'productGroup',
      value: 'Main Product Groups',
    },
    addonGroup: {
      id: 'addonGroup',
      value: 'Add-on Groups',
    },
  },
  default: {
    default: { id: 'default', value: 'All Product Types' },
  },
  subtypes: {
    physicalgoods: { id: 'physicalgoods', value: 'Physical Goods' },
    nonphysicalgoods: { id: 'nonphysicalgoods', value: 'Non-Physical Goods' },
    donations: { id: 'donations', value: 'Donations' },
  },
}

export const TEAM_OR_PARTICIPANT_PRODUCT = {
  team: { id: 'team', value: 'Team to Event', label: 'Team to Event' },
  participant: { id: 'participant', value: 'Participant to Team', label: 'Participant to Team' },
}

export const PRODUCTS_OR_GROUPS = {
  products: {
    id: 'specificProducts',
    value: 'Products',
  },
  groups: {
    id: 'productGroups',
    value: 'Product Group(s)',
  },
}

export const EVENTS = {
  status: {
    active: STATUS.active,
    inactive: STATUS.inactive,
    draft: STATUS.draft,
  },
  categories: {
    sport: { id: 'Sport', value: 'Sport' },
    massparticipation: { id: 'Mass Participation', value: 'Mass Participation' },
    programsandclinics: { id: 'Programs & Clinics', value: 'Programs & Clinics' },
    social: { id: 'Social', value: 'Social' },
    education: { id: 'Education', value: 'Education' },
    community: { id: 'Community', value: 'Community' },
    healthandfitness: { id: 'Health & Fitness', value: 'Health & Fitness' },
  },
  types: {
    ticketing: { id: 'Ticketing', value: 'Ticketing' },
    evententry: { id: 'Event Entry', value: 'Event Entry' },
  },
}

export const ORDERS = {
  status: {
    paid: STATUS.paid,
    unpaid: STATUS.unpaid,
    cancelled: STATUS.cancelled,
    refunded: STATUS.refunded,
    partialrefund: STATUS.partialrefund,
    processing: STATUS.processing,
    instalmentPlan: STATUS.instalmentPlan,
  },
}

export const ADD_ON_PRODUCT = {
  status: {
    paid: STATUS.paid,
    unpaid: STATUS.unpaid,
    cancelled: STATUS.cancelled,
    refunded: STATUS.refunded,
    partialrefund: STATUS.partialrefund,
  },
}

export const ORGS = {
  status: {
    allstatus: STATUS.allstatus,
    active: STATUS.active,
    inactive: STATUS.inactive,
  },
}

export const CAMPAIGN = {
  paymentterms: {
    manual: { id: 'manual', value: 'Manual' },
    automatic: { id: 'automatic', value: 'Automatic' },
  },
  duedateoffset: {
    7: { id: '7', value: '7 Days' },
    14: { id: '14', value: '14 Days' },
    21: { id: '21', value: '21 Days' },
    30: { id: '30', value: '30 Days' },
    60: { id: '60', value: '60 Days' },
    90: { id: '90', value: '90 Days' },
    specificdate: DATES.specificdate,
  },
  renewalactivationdayquantity: {
    days1: DAYS_WEEKS_MONTHS.days1,
    days2: DAYS_WEEKS_MONTHS.days2,
    days3: DAYS_WEEKS_MONTHS.days3,
    weeks1: DAYS_WEEKS_MONTHS.weeks1,
    weeks2: DAYS_WEEKS_MONTHS.weeks2,
    weeks3: DAYS_WEEKS_MONTHS.weeks3,
    months1: DAYS_WEEKS_MONTHS.months1,
  },
  status: {
    scheduled: STATUS.scheduled,
    cancelled: STATUS.cancelled,
    completed: STATUS.completed,
    progress: STATUS.progress,
  },
}

export const DISCOUNT = {
  type: {
    standard: { id: 'standard', value: 'Standard Discount' },
    bundle: { id: 'bundle', value: 'Bundle Discount' },
  },
  typevalues: {
    single: { id: 'single', value: 'Single Quantity' },
    multiple: { id: 'multiple', value: 'Multiple Quantity' },
  },
  status: {
    active: STATUS.active,
    inactive: STATUS.inactive,
    scheduled: STATUS.scheduled,
    expired: STATUS.expired,
    draft: STATUS.draft,
  },
  productsBy: {
    activeProducts: {
      id: 'activeProducts',
      value: 'ActiveProducts',
    },
    productType: {
      id: 'productType',
      value: 'ProductType',
    },
    specificProducts: {
      id: 'specificProducts',
      value: 'SpecificProducts',
    },
  },
  discountBy: {
    percentage: {
      id: 'percentage',
      value: 'Percentage',
    },
    amount: {
      id: 'amount',
      value: 'Amount',
    },
  },
  discountByWithBundle: {
    percentage: {
      id: 'percentage',
      value: 'Percentage',
    },
    amount: {
      id: 'amount',
      value: 'Amount',
    },
    priceCap: {
      id: 'priceCap',
      value: 'PriceCap',
    },
  },
}

export const PROMOCODE = {
  type: {
    generic: { id: 'generic', value: 'Generic Promo Code' },
    unique: { id: 'unique', value: 'Unique Promo Code' },
  },
  status: {
    active: STATUS.active,
    inactive: STATUS.inactive,
    scheduled: STATUS.scheduled,
    expired: STATUS.expired,
    draft: STATUS.draft,
  },
  applyTo: {
    products: {
      id: 'products',
      value: 'Products',
    },
    event: {
      id: 'event',
      value: 'Specific Event',
    },
    eventtemplate: {
      id: 'eventTemplate',
      value: 'Specific Event Template',
    },
    registrationform: {
      id: 'registrationForm',
      value: 'Specific Registration Form',
    },
  },
  productTypes: {
    ...PRODUCT.types,
  },
  assignmentStatus: {
    redeemed: {
      id: 'redeemed',
      value: 'Redeemed',
    },
    assigned: {
      id: 'assigned',
      value: 'Assigned',
    },
    unassigned: {
      id: 'unassigned',
      value: 'Unassigned',
    },
    voided: {
      id: 'voided',
      value: 'Voided',
    },
    new: {
      id: 'new',
      value: 'New',
    },
  },
}

export const MEMBERS = {
  status: {
    active: STATUS.active,
    inactive: STATUS.inactive,
    pendingActive: STATUS.pendingActive,
    transferredOut: STATUS.transferredOut,
  },
}
export const MEMBERSBYPRODUCT = {
  status: {
    active: STATUS.active,
    pendingActive: STATUS.pendingActive,
    cancelled: STATUS.cancelled,
    inactive: STATUS.inactive,
    pending: STATUS.pending,
  },
}
export const MEMBERSBYMEMBERTYPE = {
  status: {
    active: STATUS.active,
    pendingActive: STATUS.pendingActive,
    inactive: STATUS.inactive,
    pending: STATUS.pending,
  },
}

export const MEMBERSBYFINANCES = {
  national: {
    status: {
      nationalFinancial: { id: 'national-financial', value: 'National - Financial' },
      nationalUnfinancial: { id: 'national-unfinancial', value: 'National - Unfinancial' },
    },
  },
  state: {
    status: {
      stateFinancial: { id: 'state-financial', value: 'State - Financial' },
      stateUnfinancial: { id: 'state-unfinancial', value: 'State - Unfinancial' },
    },
  },
  association: {
    status: {
      associationFinancial: { id: 'association-financial', value: 'Association - Financial' },
      associationUnfinancial: { id: 'association-unfinancial', value: 'Association - Unfinancial' },
    },
  },
  area: {
    status: {
      areaFinancial: { id: 'area-financial', value: 'Area - Financial' },
      areaUnfinancial: { id: 'area-unfinancial', value: 'Area - Unfinancial' },
    },
  },
}

export const ACCREDITATIONS = {
  status: {
    active: STATUS.active,
    inactive: STATUS.inactive,
  },
  timePeriods: {
    days: DAYS_WEEKS_MONTHS.days,
    weeks: DAYS_WEEKS_MONTHS.weeks,
    months: DAYS_WEEKS_MONTHS.months,
    years: DAYS_WEEKS_MONTHS.years,
  },
  accreditationTypes: {
    administration: { id: 'Administration', value: 'Administration' },
    antidoping: { id: 'Anti-Doping', value: 'Anti-Doping' },
    childsafety: { id: 'Child Safety/Safeguarding', value: 'Child Safety/Safeguarding' },
    coaching: { id: 'Coaching', value: 'Coaching' },
    education: { id: 'Education', value: 'Education' },
    events: { id: 'Events', value: 'Events' },
    firstaid: { id: 'First Aid', value: 'First Aid' },
    general: { id: 'General', value: 'General' },
    medical: { id: 'Medical', value: 'Medical' },
    officiating: { id: 'Officiating', value: 'Officiating' },
    other: { id: 'Other', value: 'Other' },
    professionaldevelopment: { id: 'Professional Development', value: 'Professional Development' },
    grassroots: { id: 'Sport (Grassroots)', value: 'Sport (Grassroots)' },
    elite: { id: 'Sport (Elite)', value: 'Sport (Elite)' },
    professional: { id: 'Sport (Professional)', value: 'Sport (Professional)' },
    training: { id: 'Training', value: 'Training' },
    welfare: { id: 'Welfare', value: 'Welfare' },
  },
}

export const QUESTION_TYPES = {
  checkbox: {
    id: 'Checkbox',
    value: 'Checkbox',
  },
  date: {
    id: 'Date',
    value: 'Date',
  },
  documentUpload: {
    id: 'Document Upload',
    value: 'Document Upload',
  },
  headerText: {
    id: 'Header Text',
    value: 'Header Text',
  },
  number: {
    id: 'Number',
    value: 'Number',
  },
  paragraphText: {
    id: 'Paragraph Text',
    value: 'Paragraph Text',
  },
  picklist: {
    id: 'Picklist',
    value: 'Picklist',
  },
  termsAndConditions: {
    id: 'TermsAndConditions',
    value: 'Terms and Conditions',
  },
  text: {
    id: 'Text',
    value: 'Text',
  },
  multiPicklist: {
    id: 'multiPicklist',
    value: 'Multi Picklist',
  },
} as const

export const SORT_DIRECTION = {
  asc: {
    id: 'asc',
    value: 'Ascending',
  },
  desc: {
    id: 'desc',
    value: 'Decending',
  },
} as const

export const REPORT_PICKLIST_OPTIONS = {
  gender: {
    id: 'gender',
    filters: {
      ...GENDER,
    },
  },
  genderIdentity: {
    id: 'genderIdentity',
    filters: {
      ...GENDER_IDENTITY,
    },
  },
} as const

export const REPORT_FIELD_TYPES = {
  text: {
    id: 'text',
    filters: {
      isBlank: { id: 'isBlank', value: 'Is Blank' },
      isNotBlank: { id: 'isNotBlank', value: 'Is Not Blank' },
      startsWith: { id: 'startsWith', value: 'Starts With' },
      contains: { id: 'contains', value: 'Contains' },
      doesNotContain: { id: 'doesNotContain', value: 'Does Not Contain' },
    },
  },
  date: {
    id: 'date',
    filters: {
      isBetween: { id: 'isBetween', value: 'Is Between' },
      isBefore: { id: 'isBefore', value: 'Is Before' },
      isAfter: { id: 'isAfter', value: 'Is After' },
      anyDate: { id: 'anyDate', value: 'Any' },
    },
  },
  multiSelect: {
    id: 'multiSelect',
    filters: {
      include: { id: 'include', value: 'Includes' },
      exclude: { id: 'exclude', value: 'Excludes' },
    },
  },
  singleSelect: {
    id: 'singleSelect',
    filters: {
      is: { id: 'is', value: 'is' },
    },
  },
  number: {
    id: 'number',
    filters: {
      greaterThan: { id: 'greaterThan', value: 'Greater Than' },
      lessThan: { id: 'lessThan', value: 'Less Than' },
      equals: { id: 'equals', value: 'Equals' },
      between: { id: 'between', value: 'Between' },
      doesNotEqual: { id: 'doesNotEqual', value: 'Does Not Equal' },
    },
  },
  generic: {
    id: 'generic',
    filters: {},
  },
} as const

export const REPORTS = {
  visibility: {
    everyone: { id: 'everyone', value: 'Everyone' },
    me: { id: 'me', value: 'Only Me' },
  },
  types: {
    membershipAdvanced: { id: 'membershipAdvanced', value: 'Membership Advanced' },
    events: { id: 'events', value: 'Event Registrants' },
    memberTransactions: { id: 'memberTransactions', value: 'Transactions' },
    allMembers: { id: 'allMembers', value: 'All Members' },
  },
  categories: {
    memberReports: { id: 'memberReports', value: 'Member Reports' },
    events: { id: 'events', value: 'Event Reports' },
    transaction: { id: 'transactions', value: 'Transactions' },
  },
  fileFormats: {
    csv: {
      id: 'csv',
      value: 'csv',
    },
  },
  sortDirection: {
    [SORT_DIRECTION.asc.id]: {
      ...SORT_DIRECTION.asc,
    },
    [SORT_DIRECTION.desc.id]: {
      ...SORT_DIRECTION.desc,
    },
  },
} as const

export const StripeEntityURL = {
  au: {
    id: 'au',
    value: 'https://billing.stripe.com/p/login/14k7vt0MBga813O7ss',
  },
  nz: {
    id: 'nz',
    value: 'https://billing.stripe.com/p/login/dR6dSH2oQcV2evm000',
  },
  uk: {
    id: 'uk',
    value: 'https://billing.stripe.com/p/login/cN27tc8KQ7BFg7K4gg',
  },
}

export const DEFAULTS = {
  status: { id: 'All Status', value: 'All Status' },
  promocodetypes: { id: 'All Promo Code Types', value: 'All Promo Code Types' },
  default: { id: 'default', value: 'Please Select', label: 'Please Select' },
}

export const getConstant = ({
  id,
  value,
  returnType,
  constants,
}: {
  // biome-ignore lint/suspicious/noExplicitAny: TODO
  id?: any
  // biome-ignore lint/suspicious/noExplicitAny: TODO
  value?: any
  returnType: 'id' | 'value'
  // biome-ignore lint/suspicious/noExplicitAny: TODO
  constants: any[]
}) => {
  if ((!id && !value) || !constants) {
    return
  }

  // biome-ignore lint/suspicious/noImplicitAnyLet: TODO
  let constant
  if (id) {
    // This is to get the actual id value, as sometimes the input 'id' may not match the case sensitivity.
    constant = constants.find(x => x.id.toLowerCase() === id.toLowerCase())
  }
  if (value) {
    constant = constants.find(x => x.value.toLowerCase() === value.toLowerCase())
  }

  if (!constant) {
    return
  }

  return constant[returnType]
}
export const PRODUCT_SUB_TYPES = {
  types: {
    pysicalGoods: { id: 'pysicalGoods', value: 'Physical Goods' },
    nonPhysicalGoods: { id: 'nonPhysicalGoods', value: 'Non-Physical Goods' },
    donations: { id: 'donations', value: 'Donations' },
  },
} as const

export const DOCUMENT_CATEGORIES = {
  bankaccount: { id: 'bankaccount', value: 'Bank Account', label: 'Bank Account' },
  birthcertificate: { id: 'birthcertificate', value: 'Birth Certificate', label: 'Birth Certificate' },
  passport: { id: 'passport', value: 'Passport', label: 'Passport' },
  license: { id: 'license', value: 'License', label: 'License' },
  medicaldocuments: { id: 'medicaldocuments', value: 'Medical Documents', label: 'Medical Documents' },
  certification: { id: 'certification', value: 'Certification', label: 'Certification' },
  qualification: { id: 'qualification', value: 'Qualification', label: 'Qualification' },
  application: { id: 'application', value: 'Application', label: 'Application' },
  insurance: { id: 'insurance', value: 'Insurance', label: 'Insurance' },
  other: { id: 'other', value: 'Other', label: 'Other' },
}

export const DOCUMENT_PERMISSIONS = {
  onlythisorganisation: {
    id: 'onlythisorganisation',
    value: 'Only this organisation & Member Profile Portal',
    label: 'Only this organisation & Member Profile Portal',
  },
  anyorganisationinthehierarchy: {
    id: 'anyorganisationinthehierarchy',
    value: 'Any Parent Organisation in the hierarchy & Member Profile Portal',
    label: 'Any Parent Organisation in the hierarchy & Member Profile Portal',
  },
}
export const LEGACY_DOCUMENT_PERMISSIONS = {
  onlythisorganisation: {
    id: 'onlythisorganisation',
    value: 'Only this organisation',
    label: 'Only this organisation',
  },
  anyorganisationinthehierarchy: {
    id: 'anyorganisationinthehierarchy',
    value: 'Any organisation in the hierarchy',
    label: 'Any parent organisation in the hierarchy',
  },
}

export const LEGACY_DOCUMENT_CATEGORIES = {
  birthcertificate: { id: 'Birth Certificate', value: 'Birth Certificate' },
  passport: { id: 'Passport', value: 'Passport' },
  license: { id: 'License', value: 'License' },
  medicaldocuments: { id: 'Medical Documents', value: 'Medical Documents' },
  certification: { id: 'Certification', value: 'Certification' },
  qualification: { id: 'Qualification', value: 'Qualification' },
  other: { id: 'Other', value: 'Other' },
}

export const MEMBERSHIP_STATUS = {
  status: {
    active: { id: 'Active', value: 'Active' },
    inactive: { id: 'Inactive', value: 'History' },
  },
}

export const RULE_SUB_TYPES = {
  seasonBased: { id: 'Season based', value: 'Season based' },
  lifeLong: { id: 'Lifelong', value: 'Lifelong' },
}

export const SHOP_MEMBER_TYPES = {
  shopCustomer: { id: 'shopCustomer', value: 'Shop Customer', name: 'Shop Customer' },
}

export const CUSTOMER_TIER_OPTIONS = {
  tier1: { id: 'Tier 1', value: 'Tier 1' },
  tier2: { id: 'Tier 2', value: 'Tier 2' },
  tier3: { id: 'Tier 3', value: 'Tier 3' },
  tier4: { id: 'Tier 4', value: 'Tier 4' },
  tier5: { id: 'Tier 5', value: 'Tier 5' },
}

export const QUESTION_TYPES_OPTIONS = {
  text: { id: 'Text', value: 'Text' },
  number: { id: 'Number', value: 'Number' },
  picklist: { id: 'Picklist', value: 'Picklist' },
  multipleChoice: { id: 'multiPicklist', value: 'Multiple Choice' },
  qualificationStandards: { id: 'qualificationStandard', value: 'Qualification Standards' },
  date: { id: 'Date', value: 'Date' },
  checkbox: { id: 'Checkbox', value: 'Checkbox' },
  termsOrPrivacyPolicy: { id: 'TermsAndConditions', value: 'Terms or Privacy Policy' },
  documentUpload: { id: 'Document Upload', value: 'Document Upload' },
  headerText: { id: 'Header Text', value: 'Header Text' },
  paragraphText: { id: 'Paragraph Text', value: 'Paragraph Text' },
}

export const MEMBER_EVENT_OPTIONS = {
  eventProducts: { id: 'Event Products', value: 'Event Products' },
  eventDetails: { id: 'Event Details', value: 'Event Details' },
}

export const NOTE_CATEGORIES = {
  general: { id: 'General', value: 'General' },
  medical: { id: 'Medical', value: 'Medical' },
  welfare: { id: 'Welfare/Safeguarding', value: 'Welfare/Safeguarding' },
  disciplinary: { id: 'Disciplinary', value: 'Disciplinary' },
  other: { id: 'Other', value: 'Other' },
}

export const SYSTEM_MEMBER_TYPES = [
  {
    key: 'systemMemberTypes',
    value: [
      {
        id: 'isPlayer',
        name: 'Player',
        value: 'isPlayer',
        label: 'Participant',
      },
      {
        id: 'isCoach',
        name: 'Coach',
        value: 'isCoach',
        label: 'Coach',
      },
      {
        id: 'isTeamManager',
        name: 'Team Manager',
        value: 'isTeamManager',
        label: 'Team Manager',
      },
      {
        id: 'isGameOfficial',
        name: 'Game Official',
        value: 'isGameOfficial',
        label: 'Game Official',
      },
      {
        id: 'isVolunteer',
        name: 'Volunteer',
        value: 'isVolunteer',
        label: 'Volunteer',
      },
      {
        id: 'isMiscellaneous',
        name: 'Miscellaneous',
        value: 'isMiscellaneous',
        label: 'Miscellaneous',
      },
      {
        id: 'isEventParticipant',
        name: 'Event Participant',
        value: 'isEventParticipant',
        label: 'Event Participant',
      },
    ],
    key_prefix: '',
  },
]

export const DASHBOARD_WIDGETS = {
  productsSold: { id: 'productsSold', value: 'Current Year Products Sold' },
  paidOrders: { id: 'paidOrders', value: 'Current Year Paid Orders' },
  totalOrderValue: { id: 'totalOrderValue', value: 'Current Year Total Order Value' },
  activeMembers: { id: 'activeMembers', value: 'Total Active Members' },
  eventParticipants: { id: 'eventParticipants', value: 'Total Event Participants' },
  productTrends: { id: 'productTrends', value: 'Total # Product Sold by Month & Type' },
  orderValueTrends: { id: 'orderValueTrends', value: 'Total Order Value by Month & Type' },
  membersByType: { id: 'membersByType', value: 'Active Members by Member Type (Top 10)' },
  membersByGender: { id: 'membersByGender', value: 'Active Members by Assigned Gender' },
  membersByAge: { id: 'membersByAge', value: 'Active Members by Age Group' },
  eventsByCategory: { id: 'eventsByCategory', value: 'Events by Category (Top 10)' },
  eventParticipantsGender: { id: 'eventParticipantsGender', value: 'Event Participant by Assigned Gender' },
  eventParticipantsAge: { id: 'eventParticipantsAge', value: 'Event Participant by Age Group' },
}
